import type {ChatCoffeeLocaleId} from '../components/localeLoaders';
import type {MicrositeRoutePath} from 'microsites/core/chatMicrosite/routes/types';
import type {MicrositeRouteRegistry} from 'microsites/core/chatMicrosite/runtime/MicrositeRouteRegistryContext';

export const chatCoffeeRouteDefinitions = {
  landing: {
    id: `landing`,
    templateRelativePath: `src/templates/landingPage.template.tsx`,
    paths: {
      'ar-MA': `/ar-MA`,
      'ar-SA': `/ar-SA`,
      'de-DE': `/de-DE`,
      'en-KE': `/en-KE`,
      'en-NG': `/en-NG`,
      'en-US': `/`,
      'es-ES': `/es-ES`,
      'fa-IR': `/fa-IR`,
      'fr-FR': `/fr-FR`,
      'hi-IN': `/hi-IN`,
      'it-IT': `/it-IT`,
      'ja-JP': `/ja-JP`,
      'ko-KR': `/ko-KR`,
      'nl-NL': `/nl-NL`,
      'pt-PT': `/pt-PT`,
      'ru-RU': `/ru-RU`,
      'sv-SE': `/sv-SE`,
      'th-TH': `/th-TH`,
      'yue-Hant-HK': `/yue-Hant-HK`,
      'zh-Hans-CN': `/zh-Hans-CN`,
    } as const satisfies Record<ChatCoffeeLocaleId, MicrositeRoutePath>,
  },
  about: {
    id: `about`,
    templateRelativePath: `src/templates/aboutPage.template.tsx`,
    paths: {
      'ar-MA': `/ar-MA/على`,
      'ar-SA': `/ar-SA/عن`,
      'de-DE': `/de-DE/über-uns`,
      'en-KE': `/en-KE/about`,
      'en-NG': `/en-NG/about`,
      'en-US': `/en-US/about`,
      'es-ES': `/es-ES/sobre-nosotros`,
      'fa-IR': `/fa-IR/درباره`,
      'fr-FR': `/fr-FR/à-propos`,
      'hi-IN': `/hi-IN/के-बारे-में`,
      'it-IT': `/it-IT/su-di-noi`,
      'ja-JP': `/ja-JP/について`,
      'ko-KR': `/ko-KR/소개`,
      'nl-NL': `/nl-NL/over-ons`,
      'pt-PT': `/pt-PT/sobre-nos`,
      'ru-RU': `/ru-RU/о-нас`,
      'sv-SE': `/sv-SE/om-oss`,
      'th-TH': `/th-TH/เกี่ยวกับ`,
      'yue-Hant-HK': `/yue-Hant-HK/關於`,
      'zh-Hans-CN': `/zh-Hans-CN/关于我们`,
    } as const satisfies Record<ChatCoffeeLocaleId, MicrositeRoutePath>,
  },
} as const satisfies MicrositeRouteRegistry<ChatCoffeeLocaleId>;

export type ChatCoffeeRouteDefinitionMap = typeof chatCoffeeRouteDefinitions;
export type ChatCoffeeRouteId = keyof ChatCoffeeRouteDefinitionMap;
